import { GET as newGET, POST as newPOST } from '../@packages/dataFetch';

/**
 * @deprecated since new API version
 */
export const GET = (url, params, config = {}) => {
	return newGET(url, {
		params,
		...config,
	});
};

/**
 * @deprecated since new API version
 */
export const POST = (url, data, config = {}) => {
	return newPOST(url, {
		data,
		...config,
	});
};
